import { InvestigationsRoutePath } from "#src/routes/investigations";
import { RoutePath } from "#src/utils/route";

export const NewInvestigationRoutePath = InvestigationsRoutePath.concat(
  new RoutePath({
    path: "/new",
    title: "New Investigation",
  })
);
